<template>
  <div class="base-input">
    <input
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
      :required="required"
    >
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.base-input {
  width: 100%;
}
input {
  width: 100%;
  border-radius: 0;
  border-bottom: var(--border-3);
  font-family: 'Klavika Regular';
  font-size: 0.9rem;
  --letter-spacing: 0.025em;
  letter-spacing: var(--letter-spacing);
  margin-right: calc(-1 * var(--letter-spacing));
  color: var(--color-white-1);
  line-height: 2em;
}
input::placeholder {
  color: var(--color-gray-4);
}
</style>
